export default __webpack_public_path__ + "static/media/match_requested.3d8d3ff7.png";